<template>
  <div>
    <eden-page-header :title="'Rider Directory'" :subtitle="'Add New Rider'" />
    <rider-form :banks="banks" />
  </div>
</template>

<script>
import RiderForm from "@/components/MarketplaceLogistics/Directory/Riders/RiderForm.vue";
import details from "@/requests/vendors/details.js";

export default {
  name: "RiderAdd",
  components: {
    RiderForm,
  },
  data() {
    return {
      banks: [],
    };
  },
  created() {
    this.getBanks();
  },
  methods: {
    async getBanks() {
      try {
        const res = await details.listBanks();
        this.banks = res.data.data;
      } catch (err) {
        this.$message.error(err.message);
      }
    },
  },
};
</script>
